import { render, staticRenderFns } from "./JobDestinationParams.vue?vue&type=template&id=22be7068&"
import script from "./JobDestinationParams.vue?vue&type=script&lang=js&"
export * from "./JobDestinationParams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports